import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import { Tag } from 'antd'

export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const CardRow = styled(Flex)`
  padding: 0 25px 25px 0px;
  gap: 20px;
`
export const TopHeadingTPO = styled(Flex)`
  font-style: normal;
  font-family: 'Plus Jakarta Sans';
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #343e59;
`
export const NameCell = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
  }

  p {
    margin: 0;
    font-weight: bold;
  }

  small {
    color: #aaa;
  }
`

export const ReasonText = styled.p`
  font-size: 12px;
  color: #2b4de4;
  cursor: pointer;
  margin-bottom: 5px;

  & b {
    color: #2b4de4;
    font-weight: bold;
  }
`
export const ReasonNonText = styled.p`
  font-size: 12px;
  color: #000000;
  cursor: pointer;
  margin-bottom: 5px;
`

export const EndDateCell = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 8px;
    font-size: 14px;
  }

  .ant-tag {
    border-radius: 50%;
    width: 15px;
    height: 15px;
  }
`
export const StyledNameText = styled.p`
  font-weight: bold;
  color: #3249d7;
  font-size: 16px;
  cursor: pointer;
`

export const StyledDeatilsText = styled.p`
  margin: 0;
`
export const StyledJobTitle = styled.p`
  font-weight: bold;
  font-size: 12px;
  margin: 0;
`

export const EndDateDiv = styled.div`
  display: flex;
  flex-direction: column;
`
export const SelectedContainar = styled.div`
  padding-left: 25px;
  padding-top: 20px;
  background-color: #ffffff;
  display: flex;
  gap: 20px;
`
export const SelectedText = styled.p`
  font-weight: 500;
  color: #808697;
  font-size: 16px;
`

export const CompanyListDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  ${'' /* overflow-y: scroll; */}
  margin-left: 8px;
`
export const TablePriorityLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  font-size: small;
`

export const TableColorCircle = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
`

export const PriorityLabelDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 15px;
`
export const ApprovedButton = styled.div`
  cursor: pointer;
`

export const CustomTag = styled(Tag)`
  background-color: ${props => props.bgColor || 'gray'}; /* Default color */
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
`
